var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m1 = require("@/static/public/right.png")

  var g0 = [1, 3, 4].includes(_vm.orderType)

  var l0 = _vm.__map(_vm.list, function(t, __i0__) {
    var m0 = _vm.$getImg(t.productCover)
    var m2 = _vm.totalPrice(t)
    var m3 = _vm.totalPrice(t)
    return {
      $orig: _vm.__get_orig(t),
      m0: m0,
      m2: m2,
      m3: m3
    }
  })

  var m4 = require("static/personalCenter/service.png")

  var g1 = [50, 51].includes(_vm.detail.refundStatus)
  var g2 = [1, 3].includes(_vm.detail.orderType)
  var g3 = [50, 51].includes(_vm.detail.refundStatus)
  var g4 = [2, 3].includes(_vm.detail.orderClosedStatus)
  var g5 = [1, 3].includes(_vm.detail.orderType)
  var g6 = [30, 36, 50, 51, 60].includes(_vm.detail.refundStatus)
  var g7 = [30, 36, 50, 51, 60].includes(_vm.detail.refundStatus)
  var g8 = [30, 36, 50, 51, 60].includes(_vm.detail.refundStatus)
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m1: m1,
        g0: g0,
        l0: l0,
        m4: m4,
        g1: g1,
        g2: g2,
        g3: g3,
        g4: g4,
        g5: g5,
        g6: g6,
        g7: g7,
        g8: g8
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }